/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { Action, ActionCreator } from "../../types/Action";

export function createAction<P = void>(type: string): ActionCreator<typeof type, P> {
    return Object.assign(
        (payload: P) => ({ type, payload }),
        { type }
    );
}

export function isType<P>(action, actionCreator: ActionCreator<typeof action.type, P>): action is Action<typeof action.type, P> {
    return action.type === actionCreator.type;
}

export * from "./auth.actions";
export * from "./me.actions";
export * from "./notification.actions";
export * from "./context.actions";



// WEBPACK FOOTER //
// ./src/store/actions/index.ts